const steps = [
  {
    num: '01',
    icon: 'ri-cursor-line',
    title: 'Başlat',
    desc: '"Hemen Başla" butonuna tıkla. Kamera ve mikrofon izni ver. Birkaç saniye içinde hazırsın.',
    color: 'from-cyan-500 to-blue-600',
  },
  {
    num: '02',
    icon: 'ri-user-search-line',
    title: 'Eşleş',
    desc: 'Akıllı algoritma seni uygun biriyle eşleştirir. Filtrelerin aktifse önce tercihlerine göre arama yapar.',
    color: 'from-violet-500 to-purple-700',
  },
  {
    num: '03',
    icon: 'ri-chat-smile-3-line',
    title: 'Sohbet Et',
    desc: 'Görüntülü veya metin modunda sohbet et. Beğenmezsen "Sonraki" ile anında yenisine geç.',
    color: 'from-cyan-400 to-cyan-600',
  },
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-24 md:py-32 bg-[#05070d] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute bottom-0 right-0 w-[500px] h-[400px] rounded-full bg-cyan-500/5 blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/25 text-cyan-400 text-xs font-semibold mb-6">
            <i className="ri-route-line" />
            Nasıl Çalışır?
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            3 Adımda Başla
          </h2>
          <p className="text-white/45 text-base md:text-lg max-w-xl mx-auto">
            Üyelik gerektirmez. Anında başla, yeni insanlarla tanış.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line */}
          <div className="hidden md:block absolute top-16 left-[calc(16.66%+32px)] right-[calc(16.66%+32px)] h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((step, i) => (
              <div key={step.title} className="relative flex flex-col items-center text-center group">
                {/* Number badge */}
                <div className="relative mb-8">
                  <div
                    className={`w-16 h-16 rounded-2xl flex items-center justify-center bg-gradient-to-br ${step.color} shadow-lg transition-transform duration-300 group-hover:scale-110`}
                  >
                    <i className={`${step.icon} text-white text-2xl`} />
                  </div>
                  <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[#05070d] border border-white/15 text-white/40 text-xs flex items-center justify-center font-mono">
                    {i + 1}
                  </span>
                </div>

                <h3 className="text-white font-bold text-xl mb-3">{step.title}</h3>
                <p className="text-white/45 text-sm leading-relaxed max-w-xs">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <a
            href="/auth"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 text-white font-bold text-base hover:from-cyan-400 hover:to-violet-500 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-cyan-500/20 hover:shadow-cyan-500/35 hover:scale-105"
          >
            <i className="ri-play-fill" />
            Hemen Dene — Ücretsiz
          </a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
